import mapiConfig from "../configs/mapi";
import { httpMStepsClient } from "./utils/httpService";

const MAPI_BASE_URL = mapiConfig.api.domain;
const Controller = "/notifications";

export const getAllNotifications = async (
  page: number,
  pageSize: number,
  sort: any,
  status: string
) => {
  const methodPath = `${Controller}?page=${page}&pageSize=${pageSize}&sort=${sort}&status=${status}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const getNotificationCount = async () => {
  const methodPath = `${Controller}/count`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "GET",
    path: methodPath,
  });
};

export const readNotification = async (notificationId: string) => {
  const methodPath = `${Controller}/read/${notificationId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
  });
};

export const deleteNotification = async (notificationId: string) => {
  const methodPath = `${Controller}/delete/${notificationId}`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "DELETE",
    path: methodPath,
  });
};

export const readAllNotifications = async () => {
  const methodPath = `${Controller}/read-all`;

  return await httpMStepsClient({
    baseURL: MAPI_BASE_URL,
    type: "POST",
    path: methodPath,
  });
};
